var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CreateLayout',{attrs:{"title":"screen.users.invite","breadcrumbs":_vm.breadcrumbs},scopedSlots:_vm._u([{key:"global-menu",fn:function(){return [_c('span')]},proxy:true}])},[_c('InviteUsers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }